var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.5,
    r: 2.5,
    fill: "#002A69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00071 8C8.99697 8.00007 9.96794 8.22927 10.8396 8.6543C10.3426 8.89865 9.99973 9.40878 9.99973 10C9.1714 10.0001 8.49973 10.6716 8.49973 11.5C8.49973 12.3284 9.1714 12.9999 9.99973 13C9.99973 13.3848 10.1463 13.7345 10.3845 14H3.8259C2.6733 14 1.70594 13.0807 2.08274 12.0371C2.38994 11.1871 2.89653 10.406 3.57297 9.75781C4.74728 8.63261 6.34 8 8.00071 8ZM13.9929 12.6211C13.928 13.2589 13.375 13.7723 12.6667 13.9395C12.8742 13.6822 12.9997 13.3562 12.9997 13C13.3813 13 13.7282 12.8557 13.9929 12.6211Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5H13M11.5 10V13",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserAvatar);
export default __webpack_public_path__ + "static/media/Add_user_avatar.791cb92881909c2886bb0fc2c3713d9e.svg";
export { ForwardRef as ReactComponent };